import React from 'react'
import PropTypes from 'prop-types'

import { withStyles } from '@material-ui/core/styles'

import Faqs from 'artkive/components/Faqs'

import { faqStyles } from './Keepsakes.style'

const KeepsakeFaqs = ({ classes, ...rest }) => (
  <Faqs
    questionClassName={classes.question}
    itemClassName={classes.item}
    containerClassName={classes.container}
    {...rest}
  />
)

KeepsakeFaqs.propTypes = {
  classes: PropTypes.object.isRequired,
}

export default withStyles(faqStyles)(KeepsakeFaqs)
